<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <template v-if="detailData.list.length">
                        <el-timeline>
                            <el-timeline-item
                                :key="index"
                                :timestamp="row.Upload_Time"
                                v-for="(row, index) in detailData.list"
                                >{{ row.ProcessInfo }}</el-timeline-item
                            >
                        </el-timeline>
                    </template>
                    <template v-else>
                        <el-form label-position="left" label-width="120px" size="small">
                            <el-form-item label="物流公司：">{{
                                detailData.row.name
                            }}</el-form-item>
                            <el-form-item label="订单号：">{{
                                detailData.row.number
                            }}</el-form-item>
                            <el-form-item label="查货电话："
                                >{{ detailData.row.phone }}
                                <span
                                    class="t-primary t-pointer"
                                    @click="GetCall(detailData.row.phone)"
                                    v-if="detailData.row.phone"
                                    >呼叫</span
                                ></el-form-item
                            >
                        </el-form>
                    </template>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    inject: ['reload'],
    props: ['detailParam'],
    data() {
        return {
            detailData: {
                loading: {
                    form: false,
                    submit: false
                },
                title: '物流信息',
                list: [],
                row: {}
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.detailData.title = this.detailParam.row.express_number
        })
    },
    mounted() {
        this.$nextTick(() => {
            this.GetExpress()
        })
    },
    methods: {
        // 物流状态
        GetExpress() {
            this.$request({
                url: '/api/v1/queryExpress',
                params: {
                    ...this.detailParam.row
                }
            }).then(res => {
                if (!res.status) {
                    if (res.data.express_type === 1 || res.data.express_type === 2) {
                        this.detailData.list = res.data.list
                    } else {
                        this.detailData.row = res.data
                    }
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 呼叫
        GetCall(num) {
            this.$confirm('请稍候，我们将马上接通您的电话, 请注意接听！', '进行呼叫？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.$request({
                        url: '/api/v1/getsign',
                        params: {
                            passiveNum: num
                        }
                    }).then(res => {
                        this.$message({
                            message: res.message || (res.message ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                    })
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
.el-timeline {
    padding: 20px 0 0 1px;
}
</style>
